import client from '@/apis/aniftyBackend/client';
import { MintAskData } from '@/apis/aniftyBackend/creations/interface';

const fetchMintAskByAskHash = async (askHash: string): Promise<MintAskData> => {
  const response = await client.get<MintAskData>(
    `api/marketplace_v2/mint_ask/${askHash}`
  );
  return { ...response.data, askHash };
};

export default fetchMintAskByAskHash;
